enum PinType {
    NONE = 0,
    PUBLIC = 1,
    PRIVATE = 2
}

export default PinType;